import React from 'react';
import './Button.scss';
import { Loader } from '@design-system/index';

export type ButtonProps = {
    variant?: 'primary' | 'secondary' | 'tertiary' | 'icon' | 'icon-hover' | 'outlined' | 'transparent' | 'danger';
    color?: 'primary' | 'secondary' | 'grey' | 'grey-primary' | 'grey-secondary' | 'primary-secondary';
    size?: 'small' | 'fullwidth' | 'big' | 'large' | 'medium-square' | 'xsmall';
    icon?: React.ReactNode;
    hoverIcon?: React.ReactNode;
    iconPosition?: 'left' | 'right' | 'forced-right';
    bordered?: boolean;
    bubble?: number;
    isLoading?: boolean;
    noTransition?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const Button: React.FC<ButtonProps> = ({
    color,
    size,
    variant = 'primary',
    children,
    icon,
    hoverIcon,
    iconPosition = 'left',
    bordered = false,
    noTransition = false,
    bubble,
    isLoading = false,
    ...props
}) => {

    return (
        <button
            data-color={color}
            data-size={size}
            data-variant={variant}
            data-icon-position={iconPosition}
            data-bordered={bordered}
            data-no-transition={noTransition}
            className={`${hoverIcon ? 'icon-hover' : ''}`}
            {...props}
        >
            {iconPosition === 'left' && 
                (isLoading ? <Loader verysmall /> :
                    (icon && <><span className='icon-content'>{icon}</span>{hoverIcon && <span className='icon-content-hover'>{hoverIcon}</span>}</>)
                )}
            {children}
            {iconPosition === 'right' && 
                (isLoading ? <Loader verysmall /> :
                    (icon && <><span className='icon-content'>{icon}</span>{hoverIcon && <span className='icon-content-hover'>{hoverIcon}</span>}</>)
                )}
            {(bubble && bubble > 0) ? <span className='bubble'>{bubble}</span> : null}
        </button>
    );
    
};
